import script from "./Photovoltaic.vue?vue&type=script&setup=true&lang=ts"
export * from "./Photovoltaic.vue?vue&type=script&setup=true&lang=ts"

import "./Photovoltaic.vue?vue&type=style&index=0&id=191edcb0&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191edcb0"]])

export default __exports__